import { Alert } from '@vtex/shoreline'

import { useAPPTranslation } from '~/i18n/useAPPTranslation'

const BudgetPacingRecalcNotice = () => {
  const { t } = useAPPTranslation()

  return (
    <Alert variant="informational">
      {t('rm:budgetPacing.cyclePreview.notice')}
    </Alert>
  )
}

export default BudgetPacingRecalcNotice
